import React from 'react';

function Card({payload, onClick, active, index}) {
    let cls = 'm-lottery-card card-' + index;

    const handleClick = () => {
        onClick();
    }

    if (payload.prizeId) {
        cls += ' w-font lottery-' + payload.prizeId;
    }

    if (active) {
        cls += ' active' ;
    }

    return (
        <div className={cls} onClick={handleClick}>
            <div className="card-back"></div>
            <div className="card-font"></div>
        </div>
    );
}

export default Card;